export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="relative rounded-3xl bg-foreground-950 overflow-hidden">
          <div className="absolute top-0 left-0 w-64 h-64 rounded-full bg-primary-500/10 -translate-x-1/3 -translate-y-1/3 blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-80 h-80 rounded-full bg-accent-500/10 translate-x-1/3 translate-y-1/3 blur-3xl"></div>

          <div className="relative flex flex-col lg:flex-row">
            <div className="w-full lg:w-2/5 p-8 md:p-12 lg:p-0 lg:py-0 flex items-end">
              <img
                src="https://readdy.ai/api/search-image?query=Confident%20young%20professional%20in%20casual%20blazer%20holding%20tablet%20leaning%20against%20warm%20terracotta%20wall%2C%20genuine%20smile%2C%20soft%20natural%20daylight%2C%20modern%20lifestyle%20portrait%2C%20cream%20and%20rust%20tones%2C%20authentic%20relaxed%20expression%2C%20editorial%20quality%2C%20high%20detail&width=600&height=800&seq=testimonial-portrait-v2&orientation=portrait"
                alt="Happy Sugargoo Spreadsheet user sharing their experience"
                title="Sugargoo Spreadsheet Community Review"
                className="w-full h-auto lg:h-[480px] object-cover object-top rounded-2xl lg:rounded-none"
                loading="lazy"
              />
            </div>

            <div className="w-full lg:w-3/5 p-8 md:p-12 lg:p-14 flex flex-col justify-center">
              <span className="text-7xl md:text-9xl font-heading font-bold text-primary-500/30 leading-none select-none">&ldquo;</span>
              <p className="-mt-6 text-base md:text-lg text-background-50 leading-relaxed">
                Using a Sugargoo Spreadsheet completely changed how I shop. I used to lose track of orders and overpay on shipping, but now everything is organized in one place. The category navigation on this site makes finding what I need incredibly fast. Seriously, I have saved hundreds on shipping alone since I started using the spreadsheet approach.
              </p>
              <div className="mt-6">
                <p className="text-sm font-semibold text-background-50">Marcus T.</p>
                <p className="text-xs text-background-50/60 mt-0.5">Verified Sugargoo Spreadsheet User</p>
              </div>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="mt-6 inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap w-fit"
              >
                Start Shopping Now
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}